export default "__VITE_ASSET__QF$VqvZm__"